import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const variants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-14 md:py-24 px-5 md:px-6 bg-[#0a0e1a]" data-id="element-140">
      <div className="max-w-2xl mx-auto" data-id="element-141">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} variants={variants} className="space-y-8 md:space-y-12" data-id="element-142">
          <div className="space-y-4 md:space-y-6" data-id="element-143">
            <h2 className="text-2xl md:text-4xl font-playfair text-[#f5f0e8]" data-id="element-144">
              If this is you, you already know how tonight goes.
            </h2>

            <p className="text-lg md:text-xl text-[#e8e0d4] leading-relaxed" data-id="element-145">
              You wake up between{' '}
              <strong className="text-[#c9a96e]" data-id="element-146">3 and 5am</strong>.
            </p>

            <p className="text-base md:text-lg text-[#e8e0d4] leading-relaxed" data-id="element-147">
              Sometimes it's a jolt. Sometimes it's subtle.
              <br data-id="element-148" />
              But your mind does the same thing every time:
            </p>
          </div>

          <ul className="space-y-4 md:space-y-6 pl-2 md:pl-4" data-id="element-149">
            {['It starts scanning tomorrow', 'It starts negotiating with your body', 'It starts trying to "fix" sleep while you\'re still in the dark'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.8
          }} className="flex items-start text-base md:text-xl text-[#e8e0d4]" data-id="element-150">
                <span className="text-[#c9a96e] mr-3 md:mr-4 text-lg md:text-xl mt-0.5" data-id="element-151">
                  ✦
                </span>
                {item}
              </motion.li>)}
          </ul>

          <motion.div variants={variants} transition={{
          duration: 1
        }} className="space-y-4 md:space-y-6" data-id="element-152">
            <p className="text-lg md:text-xl text-[#e8e0d4] leading-relaxed" data-id="element-153">
              And the more you try, the more awake you become.
            </p>

            <div className="border-l-4 border-[#c9a96e] pl-4 md:pl-6 py-2 my-4 md:my-8 bg-[#111827]/30 rounded-r-lg backdrop-blur-sm" data-id="element-154">
              <p className="text-lg md:text-2xl font-playfair italic text-[#f5f0e8] leading-relaxed" data-id="element-155">
                Not because you're doing it wrong.
                <br data-id="element-156" />
                Because your brain is reading your effort as{' '}
                <span className="text-[#c9a96e] not-italic font-bold" data-id="element-157">
                  danger
                </span>
                .
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}